module.exports = __webpack_public_path__ + "img/recycling.0f58986.webp";